export default __webpack_public_path__ + "static/media/vipBg.a66b272d.jpg";